<template>
    <div class="account-pages w-100 mt-5 mb-5">
        <div class="content">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-8 col-xl-8">
                        <div class="backgroundColorRed card-radius-top topBorderCard"></div>

                        <div class="card-box">
                            <router-link to="/" class="cursor-pointer">
                                <i class="mdi mdi-keyboard-backspace btn-back"></i>{{ `` }}<span class="btn-back">{{ $t('string.msg.form.btn.goback') }}</span>
                            </router-link>
                            <div class="text-center mb-4">
                                <span><img src="assets/images/logo_preto@2x.png" alt="" height="60px" /></span>
                            </div>
                            <h4 class="header-title">{{ $t('string.msg.company.label.title') }}</h4>
                            <p class="sub-header">
                                {{ $t('string.msg.company.label.decription') }}
                            </p>

                            <form>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.fantasyName') }}
                                        </label>
                                        <input type="text" v-model="data.fantasyName" class="form-control" :placeholder="$t('string.msg.company.placeholder.fantasyName')" />
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.socialName') }}
                                        </label>
                                        <input type="text" v-model="data.socialName" class="form-control" :placeholder="$t('string.msg.company.placeholder.socialName')" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.document') }}
                                        </label>
                                        <input
                                            type="tel"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                                            v-model="data.document"
                                            class="form-control"
                                            :placeholder="$t('string.msg.company.placeholder.document')"
                                        />
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <!-- <code v-if="!data._id" class="highlighter-rouge">*</code> -->
                                            {{ $t('string.msg.company.label.stateSubscription') }}
                                        </label>
                                        <input
                                            v-model="data.stateSubscription"
                                            type="text"
                                            class="form-control"
                                            :placeholder="$t('string.msg.company.placeholder.stateSubscription')"
                                            v-mask="['###.###.###.###']"
                                        />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code v-if="!data._id" class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.primaryPhone') }}
                                        </label>
                                        <input
                                            v-model="data.primaryPhone"
                                            type="text"
                                            class="form-control"
                                            :placeholder="$t('string.msg.company.placeholder.primaryPhone')"
                                            v-mask="['(##) ####-####', '(##) #####-####']"
                                        />
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code v-if="!data._id" class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.main.email') }}
                                        </label>
                                        <input type="text" v-model="data.email" class="form-control" :placeholder="$t('string.msg.company.placeholder.main.email')" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.isbranch') }}
                                        </label>
                                        <select v-model="data.isBranch" class="form-control">
                                            <option :value="false">{{ $t('string.msg.no') }}</option>
                                            <option :value="true">{{ $t('string.msg.yes') }}</option>
                                        </select>
                                    </div>

                                    <div v-if="data.isBranch == true" class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.document.main') }}
                                        </label>
                                        <input type="tel" v-mask="'##.###.###/####-##'" v-model="data.mainCompany" class="form-control" :placeholder="$t('string.msg.company.placeholder.document')" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-12">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.type') }}
                                        </label>
                                        <div class="d-flex flex-wrap">
                                            <div class="container-switch" v-bind:key="item.id" v-for="item in this.types">
                                                <label class="switch">
                                                    <input v-model="data.typeService" type="checkbox" :id="item._id" :value="item._id" :true-value="item._id" :false-value="null" />
                                                    <span class="slider round"></span>
                                                </label>
                                                <span class="label-swith">{{ item.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <br /><br />
                                <div class="form-row">
                                    <div class="form-group col-sm-2">
                                        <label>
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.cep') }}
                                        </label>
                                        <input @blur="loadInfosByCEP" v-mask="'#####-###'" v-model="data.address.cep" type="tel" class="form-control" :placeholder="$t('string.msg.company.label.cep')" />
                                    </div>
                                </div>
                                <div v-if="data.address.cep && data.address.cep.length == 9" class="form-row">
                                    <div class="form-group col-sm-2">
                                        <label>
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.state') }}
                                        </label>
                                        <select v-model="data.address.state" class="form-control select2">
                                            <option value="-1" selected>{{ $t('string.msg.element.select.selectitem') }}</option>
                                            <option value="AC">AC</option>
                                            <option value="AL">AL</option>
                                            <option value="AP">AP</option>
                                            <option value="AM">AM</option>
                                            <option value="BA">BA</option>
                                            <option value="CE">CE</option>
                                            <option value="DF">DF</option>
                                            <option value="ES">ES</option>
                                            <option value="GO">GO</option>
                                            <option value="MA">MA</option>
                                            <option value="MT">MT</option>
                                            <option value="MS">MS</option>
                                            <option value="MG">MG</option>
                                            <option value="PA">PA</option>
                                            <option value="PB">PB</option>
                                            <option value="PR">PR</option>
                                            <option value="PE">PE</option>
                                            <option value="PI">PI</option>
                                            <option value="RJ">RJ</option>
                                            <option value="RN">RN</option>
                                            <option value="RS">RS</option>
                                            <option value="RO">RO</option>
                                            <option value="RR">RR</option>
                                            <option value="SC">SC</option>
                                            <option value="SP">SP</option>
                                            <option value="SE">SE</option>
                                            <option value="TO">TO</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.city') }}
                                        </label>
                                        <input v-model="data.address.city" type="text" class="form-control" :placeholder="$t('string.msg.company.label.city')" />
                                    </div>
                                    <div class="form-group col-sm-4">
                                        <label>
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.street') }}
                                        </label>
                                        <input v-model="data.address.address" type="text" class="form-control" :placeholder="$t('string.msg.company.label.street')" />
                                    </div>
                                    <div class="form-group col-sm-2">
                                        <label>
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.number') }}
                                        </label>
                                        <input v-model="data.address.number" type="text" class="form-control" :placeholder="$t('string.msg.company.label.number')" />
                                    </div>
                                </div>
                                <div v-if="data.address.cep && data.address.cep.length == 9" class="form-row">
                                    <div class="form-group col-sm-5">
                                        <label>
                                            <code class="highlighter-rouge">*</code>
                                            {{ $t('string.msg.company.label.neighborhood') }}
                                        </label>
                                        <input v-model="data.address.neighborhood" type="text" class="form-control" :placeholder="$t('string.msg.company.label.neighborhood')" />
                                    </div>
                                    <div class="form-group col-sm-4">
                                        <label>
                                            {{ $t('string.msg.company.label.complement') }}
                                        </label>
                                        <input v-model="data.address.complement" type="text" class="form-control" :placeholder="$t('string.msg.company.label.complement')" />
                                    </div>
                                </div>

                                <div v-if="errors.length" class="alert alert-danger">
                                    <p class="lead">{{ $t('response.msg.error.empty.fields') }}</p>
                                    <ul>
                                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                    </ul>
                                </div>

                                <br />

                                <div class="form-row">
                                    <div v-if="data.address.cep && data.address.cep.length == 9" class="form-group col-md-3">
                                        <button v-on:click="checkForm" class="btn btn-danger w-100">{{ $t('string.msg.form.btn.save') }}</button>
                                    </div>
                                    <div v-if="!data.address.cep || data.address.cep.length < 9" class="form-group col-md-3">
                                        <button class="btn btn-light w-100">{{ $t('string.msg.form.btn.save') }}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <ModalAddress :addresses="addresses" v-on:select-address="selectAddress" />
        <FlashMessage />
    </div>
</template>

<script>
import Controller from './CrtCompany'
import Spinner from '../../components/layout/Spinner'
import ModalAddress from './Modal/ModalAddress'
import Toast from '../../components/layout/Toast'

export default {
    name: 'User',
    components: {
        Spinner,
        Toast,
        ModalAddress,
    },
    data() {
        return {
            errors: [],
            addresses: [],
            valuekey: 0,
            text: '',
            types: [
                { _id: 'PART_SUPPLIER', name: this.$t('string.msg.company.label.type.autoparts') },
                { _id: 'CERTIFIER', name: this.$t('string.msg.company.label.type.certifier') },
                { _id: 'SERVICE_PROVIDER', name: this.$t('string.msg.company.label.type.serviceprovider') },
                { _id: 'FLEET_DRIVER', name: this.$t('string.msg.company.label.type.fleetdriver') },
                { _id: 'GAS_STATION', name: this.$t('string.msg.user.gasstation.label.title') },
            ],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            checkTerm: null,
            data: {
                status: 'ACTIVE',
                isBranch: false,
                fantasyName: null,
                socialName: null,
                email: null,
                document: null,
                date: new Date(),
                address: {
                    state: -1,
                    cep: null,
                    city: null,
                    address: null,
                    neighborhood: null,
                    number: null,
                },
                primaryPhone: null,
                typeService: [],
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
    },
    mounted() {},
}
</script>

<style>
</style>
